// src/hooks/useIdleTimeout.js
import { useEffect } from "react";

export default function useIdleTimeout({
    idleMinutes = 20,
    warnBeforeSeconds = 120,
    onWarn,      // gets called every second in warn window with remaining seconds
    onTimeout,   // called once at/after timeout
}) {
    useEffect(() => {
        let last = Date.now();

        const bump = () => { last = Date.now(); };

        const events = ["click", "keydown", "mousemove", "scroll", "touchstart"];
        events.forEach(e => window.addEventListener(e, bump, { passive: true }));

        const timer = setInterval(() => {
            const elapsed = (Date.now() - last) / 1000;
            const total = idleMinutes * 60;
            const remain = Math.ceil(total - elapsed);

            if (remain <= 0) {
                onTimeout?.();
                return;
            }

            if (remain <= warnBeforeSeconds) {
                onWarn?.(remain); // update the dialog every second
            }
        }, 1000);

        return () => {
            clearInterval(timer);
            events.forEach(e => window.removeEventListener(e, bump));
        };
    }, [idleMinutes, warnBeforeSeconds, onWarn, onTimeout]);
}
